import { useEffect, useState } from 'react';
import { Box, Button, Container, Link, Stack, useTheme } from '@mui/joy';
import { motion, AnimatePresence } from 'framer-motion';
import Logo, { LogoText } from '../../../components/module/Logo/Logo';
import { useMediaQuery } from '@mui/material';

const ACCENT_COLOR_LIGHT = '#000';
const ACCENT_COLOR_DARK = '#fff';

const HEADER_LINKS = [
    { label: 'Возможности', href: '#features' },
    { label: 'Безопасность', href: '#security' },
    { label: 'Вопросы', href: '#faq' },
];

export function WelcomeHeader() {
    const theme = useTheme();
    const isMobile = useMediaQuery('(max-width: 899px)');
    const isSmall = useMediaQuery('(max-width: 600px)');
    const isDark = theme.colorSchemes?.dark && theme.palette.mode === 'dark';
    const [show, setShow] = useState(false);

    useEffect(() => {
        const onScroll = () => {
            const hero = document.getElementById('hero');
            const threshold = hero ? hero.offsetHeight - 72 : 560;
            setShow(window.scrollY > threshold);
        };
        onScroll();
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    return (
        <AnimatePresence>
            {show && (
                <motion.div
                    initial={{ y: isSmall ? 24 : -24, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{ y: isSmall ? 24 : -24, opacity: 0 }}
                    transition={{ duration: 0.25, ease: 'easeOut' }}
                    style={{
                        position: 'fixed',
                        left: 0,
                        right: 0,
                        zIndex: 1100,
                        ...(isSmall ? { bottom: 10 } : { top: 0 }),
                    }}
                >
                    <Container component="header" maxWidth="lg" sx={{ pt: isSmall ? 0 : 1.5, pb: isSmall ? 1.5 : 0 }}>
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                gap: 2,
                                px: { xs: 2, md: 3 },
                                py: 2,
                                borderRadius: '999px',
                                backgroundColor: `${theme.palette.background.body}cc`,
                                backdropFilter: 'blur(12px)',
                                border: '1px solid',
                                borderColor: 'divider',
                                boxShadow: '0 8px 30px rgba(20, 130, 127, 0.12)',
                            }}
                        >
                            <Link href="/welcome" aria-label="Аквариум — на главную" sx={{ display: 'flex', alignItems: 'center', minWidth: 0, flexShrink: 1 }}>
                                {/* <LogoText
                                    color={isDark ? ACCENT_COLOR_DARK : ACCENT_COLOR_LIGHT}
                                    colorText={isDark ? ACCENT_COLOR_DARK : ACCENT_COLOR_LIGHT}
                                    width={isMobile ? '130' : '150'}
                                    height="auto"
                                    sx={{
                                        maxWidth: '100%',
                                        height: 'auto',
                                        display: 'block',
                                        ...(isMobile ? { transform: 'translate(0,2px)' } : {}),
                                    }}
                                /> */}
                                <Box sx={{
                                    '& a': {
                                        maxHeight: '24px',
                                        maxWidth: '100%',
                                        height: 'auto',
                                        display: 'block',
                                        // transform: 'translateY(2px)',
                                        // ...(isMobile ? { transform: 'translateY(2px)' } : {}),
                                    }
                                }}>
                                    <Logo />
                                </Box>
                            </Link>

                            <Stack
                                direction="row"
                                spacing={3}
                                alignItems="center"
                                sx={{ display: { xs: 'none', md: 'flex' }, mx: 'auto' }}
                            >
                                {HEADER_LINKS.map((l) => (
                                    <Link key={l.href} href={l.href} level="body-sm" color="neutral" sx={{ textDecoration: 'none' }}>
                                        {l.label}
                                    </Link>
                                ))}
                            </Stack>

                            <Button
                                component="a"
                                href="https://aquarium.org.ru/auth"
                                size="sm"
                                sx={{ borderRadius: '999px', px: 2.5, fontWeight: 700, flexShrink: 0, textDecoration: 'none !important' }}
                            >
                                Создать аккаунт
                            </Button>
                        </Box>
                    </Container>
                </motion.div>
            )}
        </AnimatePresence>
    );
}
